/**
 * Where the other app lives. The customer app and the admin panel are
 * separate builds on separate domains; each needs the other's address for a
 * handful of links ("Open as admin", "Platform admin").
 *
 * Set at build time with VITE_APP_URL / VITE_ADMIN_URL. Without them the
 * address is derived: admin.<domain> <-> <domain>, and in development the
 * two Vite ports (5173 customer, 5174 admin).
 */
const loc = typeof window === 'undefined' ? null : window.location;
const env = import.meta.env as Record<string, string | undefined>;
const isLocal = !loc || loc.hostname === 'localhost' || loc.hostname === '127.0.0.1';

function derive(admin: boolean): string {
  if (!loc) return '';
  if (isLocal) return `${loc.protocol}//${loc.hostname}:${admin ? 5174 : 5173}`;
  const bare = loc.hostname.replace(/^admin\./i, '');
  return `${loc.protocol}//${admin ? `admin.${bare}` : bare}`;
}

export const CUSTOMER_APP_URL = (env.VITE_APP_URL ?? derive(false)).replace(/\/$/, '');
export const ADMIN_APP_URL = (env.VITE_ADMIN_URL ?? derive(true)).replace(/\/$/, '');
